export type Width = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11';

export const widthStyles: Record<Width, string> = {
  '1': 'lg:col-span-1',
  '2': 'lg:col-span-2',
  '3': 'lg:col-span-3',
  '4': 'lg:col-span-4',
  '5': 'lg:col-span-5',
  '6': 'lg:col-span-6',
  '7': 'lg:col-span-7',
  '8': 'lg:col-span-8',
  '9': 'lg:col-span-9',
  '10': 'lg:col-span-10',
  '11': 'lg:col-span-11',
};

const inverseWidthMap: Record<Width, Width> = {
  '1': '11',
  '2': '10',
  '3': '9',
  '4': '8',
  '5': '7',
  '6': '6',
  '7': '5',
  '8': '4',
  '9': '3',
  '10': '2',
  '11': '1',
};

export function useWidthClass(width?: Width) {
  return width ? widthStyles[width] : '';
}
export function useInverseWidthClass(width?: Width) {
  return width ? widthStyles[inverseWidthMap[width]] : '';
}
